<template>
  <b-card
    :title="test.title"
    :img-src="test.img"
    :img-alt="test.title"
    img-top
    tag="article"
    class="mb-2"
  >
    <b-card-text>
      {{ test.text }}
    </b-card-text>
    <template v-slot:footer>
        <h6 class="mb-0"><strong>Photo:</strong> {{ test.credit }}</h6>
      </template>
  </b-card>
</template>

<script>
export default {
  name: 'TestingCard',
  props: ['test']
}
</script>

<style scoped>
img {
  object-fit: cover;
  max-height: 190px;
}
.card {
  min-width: 18rem;
  margin-bottom: 16px !important;
}
</style>